<template>
  <PageContentLayoutOnly>
    <ListSuggestionConversations
      :style="{ overflowX: 'auto', flexGrow: 2, marginTop: '-40px' }"
      :suggestionID="parseInt(suggestionID)"
    />
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ListSuggestionConversations from '@/pages/Shared/communications/Global/List'
import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'SuggestionConversations',

  components: {
    PageContentLayoutOnly,
    ListSuggestionConversations
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {},

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { suggestionConversations: { title: 'Conversations' } }
    }
  }
}
</script>

<style></style>
